module.exports = __webpack_public_path__ + "img/3-dash.6f2d9de2.png";